module.exports = __webpack_public_path__ + "static/media/Choirpal.dbcffb84.svg";